module.exports = __webpack_public_path__ + "media/images/3-db398932d007b2f72074b3fc33bd8c28.svg";